import { itiMessageService, itiPermissionService, itiTokenService } from '@/iti-core-vue';
import templatesModule from '@/store/modules/templates.module';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider } from 'vee-validate';
import { Field } from '@/shared/dtos/field';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling } from 'devextreme-vue/data-grid';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import {
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxStringLengthRule,
} from 'devextreme-vue/validator';
import { Permission } from '@/shared/permissions';

@Component({
    components: {
        ValidationProvider,
        ItiIconButton,
        DxSelectBox,
        DxTextBox,
        DxNumberBox,
        DxTextArea,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxStringLengthRule,
        DxValidationSummary,
        DxDropDownBox,
        DxTreeView,
        DxCheckBox,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxFilterRow,
        DxScrolling
    },
})

export default class PlantillaFormulario extends Vue {
    @Prop() idPlantilla !: number;
    @Prop() idVersion !: number;
    public loading = false;
    public search = "";
    public treeBoxValue: any = null;
    public beforeTreeBoxValue: any = null;
    public treeViewName = 'tree-view';
    public categoriesDescription = "";
    public offerOrDemand = "";



    public get headers() {
        return [
            new ItiVHeader('code', 'plantillas.fieldCode'),
            new ItiVHeader('label', 'plantillas.fieldLabel'),
            new ItiVHeader('fieldType.code', 'plantillas.fieldTypecode'),
            new ItiVHeader('description', 'plantillas.fieldDescription').withWidth(300),
            new ItiVHeader('action', '').withWidth(50),
        ];
    }

    public get editTemplateVersion() {
        return templatesModule.selectedTemplateVersion;
    }


    public get fields() {
        return templatesModule.templateFields;
    }


    public get templateTitle() {
        if (templatesModule.selectedTemplate.title == null || templatesModule.selectedTemplate.title.length == 0) {
            return this.$t('plantillas.nuevaPlantilla');
        } else {
            return templatesModule.selectedTemplate.title;
        }
    }

    public get hasPermission() {
        return itiPermissionService.hasPermission(Permission.updateTemplates);
    }

    public get numVersion() {
        if (this.editTemplateVersion.version) {
            return this.editTemplateVersion.version
        } else if (templatesModule.selectedTemplate.templateVersions!= null) {
            var res = templatesModule.selectedTemplate.templateVersions.map(function (a) { return a.version });
            return (Math.max.apply(null, res) + 1);
        } else {
            return null;
        }
    }

    public async created() {
        if (!isNaN(this.idVersion) && this.idVersion != 0) {
            await templatesModule.getTemplateVersionById(this.idVersion);
            templatesModule.setTemplateEditMode(true);
        }
        if (!isNaN(this.idPlantilla) && this.idPlantilla != 0) {
            await templatesModule.getTemplateById(this.idPlantilla);
        }
    }

    public async mounted() {
        if (!isNaN(this.idVersion) && this.idVersion != 0) {
            await templatesModule.getTemplateVersionById(this.idVersion);
            templatesModule.setTemplateEditMode(true);
        }
        if (!isNaN(this.idPlantilla) && this.idPlantilla != 0) {
            await templatesModule.getTemplateById(this.idPlantilla);
        }
    }

    public async saveTemplate() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                this.editTemplateVersion.templateId = this.idPlantilla;
                templatesModule.saveTemplateVersion(this.editTemplateVersion)
                    .then(async () => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.ok'), 'success', 3000);
                        this.$router.push({ name: 'ListaVersiones', params: { id: this.idPlantilla.toString() } });
                    })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            }
        });
    }

    public cancelVersion() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-salir'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                // if (this.editTemplate.version != null) {
                templatesModule.getTemplateById(templatesModule.selectedTemplate.id);
                templatesModule.setTemplateEditMode(true);
                if (templatesModule.selectedTemplate.id != null)
                    this.$router.push({ name: 'ListaVersiones', params: { id: templatesModule.selectedTemplate.id.toString() } });
                else
                    this.$router.push({ name: 'ListaPlantillas' });
                // } else {
                //     this.$router.push({ name: 'ListaPlantillas' });
                // }
            }
        });
    }




    public editTemplateParams() {
        templatesModule.getTemplateVersionById(templatesModule.selectedTemplate.id);
        templatesModule.setTemplateEditMode(false);
        this.beforeTreeBoxValue = this.treeBoxValue;
    }

    public async createNewField() {
        templatesModule.newField();
        if ((!isNaN(templatesModule.selectedTemplateVersion.id) && templatesModule.selectedTemplateVersion.id != 0)) {
            this.$router.push({ name: 'NuevoCampoFormulario', params: { idPlantilla: this.idPlantilla.toString(), idVersion: this.idVersion.toString(), idCampo: '0' } });
        } else {
            this.$router.push({ name: 'NuevoCampoFormulario', params: { idPlantilla: '0', idVersion: '0', idCampo: '0' } });
        }
    }

    public deleteField(field: Field) {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-borrar-campo'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                templatesModule.deleteFieldFromTemplate(field);
                templatesModule.getValuesByFieldId(field.id) //Eliminar cada uno de los valores de ListValours
                    .then(() => {
                        templatesModule.values.forEach(element => {
                            templatesModule.deleteValues(element);
                        });
                    });
                templatesModule.saveTemplateVersion(this.editTemplateVersion)
                    .then(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-eliminar'), 'success', 3000);
                    })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            }
        });
    }

    public editFieldParams(field: Field) {
        templatesModule.setFieldToEdit(field);
        if (field.id) {
            this.$router.push({ name: 'NuevoCampoFormulario', params: { idPlantilla: this.idPlantilla.toString(), idVersion: this.idVersion.toString(), idCampo: field.id.toString() } });
        } else {
            this.$router.push({ name: 'NuevoCampoFormulario' });
        }
    }

    public formattedContent(contenido: string) {
        if (contenido && contenido.length > 40) {
            return String(contenido).substring(0, 40) + "...";
        } else {
            return contenido;
        }
    }

    public translateState(active: boolean) {
        return this.$tc(active.toString());

    }

}